(function () {
  'use strict';

  /* ---------- announcement bar rotator ----------
     Reads messages from DOM blocks so the theme editor controls them.
  ---------------------------------------------------------------- */
  var annItems = [].slice.call(document.querySelectorAll('.fc-announce-msg'));
  if (annItems.length > 1) {
    var annIdx = 0;
    setInterval(function () {
      var cur = annItems[annIdx];
      cur.style.opacity = '0';
      setTimeout(function () {
        cur.style.display = 'none';
        annIdx = (annIdx + 1) % annItems.length;
        var next = annItems[annIdx];
        next.style.display = '';
        next.offsetHeight; // force reflow before fade-in
        next.style.opacity = '1';
      }, 420);
    }, 5200);
  }

  /* ---------- sticky header shrink ---------- */
  var fcHeader = document.getElementById('fc-header-section');
  if (fcHeader) {
    function onScroll() {
      if (window.scrollY > 24) fcHeader.classList.add('fc-scrolled');
      else fcHeader.classList.remove('fc-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile menu drawer ---------- */
  var fcScrim   = document.getElementById('fc-scrim');
  var fcDrawer  = document.getElementById('fc-drawer');
  var fcOpenBtn = document.getElementById('fc-open-menu');
  var fcCloseBtn= document.getElementById('fc-close-menu');

  function openDrawer() {
    if (fcDrawer) fcDrawer.classList.add('fc-open');
    if (fcScrim)  fcScrim.classList.add('fc-open');
    document.body.style.overflow = 'hidden';
    if (fcDrawer) fcDrawer.focus();
  }
  function closeAll() {
    if (fcDrawer) fcDrawer.classList.remove('fc-open');
    if (fcScrim)  fcScrim.classList.remove('fc-open');
    document.body.style.overflow = '';
  }

  if (fcOpenBtn)  fcOpenBtn.addEventListener('click', openDrawer);
  if (fcCloseBtn) fcCloseBtn.addEventListener('click', closeAll);
  if (fcScrim)    fcScrim.addEventListener('click', closeAll);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  document.querySelectorAll('.fc-menu-link').forEach(function (a) {
    a.addEventListener('click', closeAll);
  });

  /* ---------- reveal on scroll ---------- */
  var reveals = [].slice.call(document.querySelectorAll('.fc-reveal'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('fc-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
    /* fallback: reveal anything still hidden after 2.6 s */
    setTimeout(function () {
      reveals.forEach(function (el) {
        if (!el.classList.contains('fc-in')) {
          el.style.transition = 'none';
          el.classList.add('fc-in');
        }
      });
    }, 2600);
  } else {
    reveals.forEach(function (el) { el.classList.add('fc-in'); });
  }

  /* ---------- header bag count ----------
     The count is rendered by Liquid, so it went stale whenever the cart changed
     without a page load (quantity steppers and Remove on the cart page). The
     theme fires 'cart:update' after every cart change; sync from it. */
  function setBagCount(n) {
    var badge = document.querySelector('.fc-cart-count');
    if (!badge || typeof n !== 'number' || isNaN(n)) return;
    badge.textContent = n;
    badge.classList.toggle('fc-show', n > 0);
    var link = badge.closest('a');
    if (link) link.setAttribute('aria-label', 'Cart (' + n + ' items)');
  }
  document.addEventListener('cart:update', function (e) {
    var d = (e && e.detail) || {};
    if (d.data && d.data.didError) return;
    var n = d.data && typeof d.data.itemCount === 'number' ? d.data.itemCount
          : d.resource && typeof d.resource.item_count === 'number' ? d.resource.item_count
          : null;
    if (n !== null) { setBagCount(n); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setBagCount(cart.item_count); })
      .catch(function () {});
  });

  /* ---------- PDP notices follow the selected variant ----------
     The Affirm message and the lead-time / local-only notices under the price
     are rendered by Liquid for one variant (snippets/fc-affirm-message.liquid,
     snippets/fc-pdp-notices.liquid). On a variant change Horizon only swaps the
     parts it knows about, so swap ours for the fresh copies that come back in
     the same section HTML, then let Affirm redraw its message. */
  function refreshAffirm() {
    var a = window.affirm;
    if (!a || !a.ui || typeof a.ui.ready !== 'function') return;
    a.ui.ready(function () {
      if (window.affirm.ui.refresh) window.affirm.ui.refresh();
    });
  }
  document.addEventListener('variant:update', function (e) {
    var html = e && e.detail && e.detail.data && e.detail.data.html;
    if (!html || typeof html.querySelector !== 'function') return;
    var swapped = false;
    document.querySelectorAll('[data-fc-variant-swap]').forEach(function (el) {
      var key = el.getAttribute('data-fc-variant-swap');
      var fresh = html.querySelector('[data-fc-variant-swap="' + key + '"]');
      if (!fresh) return;
      el.replaceWith(document.importNode(fresh, true));
      swapped = true;
    });
    if (swapped) refreshAffirm();
  });
  document.addEventListener('shopify:section:load', refreshAffirm);
})();
